/**
* In this file use to contains the physician Module Development screen UI and Logic
**/
import { Modal,Button } from 'react-bootstrap';
import { useState, useEffect } from 'react';
import ApiService from './../../services/ApiService';
import { postAnalytics } from './../../services/ReusabilityService';
import Development from './../components/Development';
import constantVariables from './../../dataset/constantVariables.json';
import { useTranslation } from 'react-i18next';

function DevelopmentModal(props) {
	
	//Intial state declaration
	const [data,setData]=useState([]);	
	const role = Number(localStorage.getItem('role'));
	const { t } = useTranslation();
	//Component initialize function
	useEffect(()=>{
			(async()=>{			
				var response = await ApiService.getMemberDevelopment({id:props.data.id});
				if(response.status===200){
					await setData(response?.data?.items);	
					sessionStorage.setItem('screenStartTime', new Date());
				}else{
					console.log('Error',response);
				}
			})();	
			
	    //To post the Analytics data
		return async()=>{
			var reqData={};
			reqData.parent = props.data.parent;
			reqData.member = props.data.id;
			reqData.module = 'development';
			postAnalytics(reqData);
		}
		
	},[props]);
	
	
  return (
  <Modal 
	show={props.data.development} 
	onHide={props.handleClose}  
	backdrop="static"
    keyboard={false}
	size="xl"
    aria-labelledby="contained-modal-title-vcenter"
    centered
  >
      <Modal.Header closeButton className={`${role===4?'admin-modal-header':''}`}>
        <Modal.Title><h5 className="modal-title text-capitalize" id="developmentModalLabel">{props.data?.name}{t('common.possessive_suffix')} {t('sidebar.development')}</h5></Modal.Title>
      </Modal.Header>
      <Modal.Body>
	  {/*Import Development Screen*/}
	    <Development data={data} />
	  </Modal.Body>
	  {/*Footer*/}
	  <Modal.Footer>
	    <Button variant="secondary" className={`btn btn-sm ${role===4?'btn-tmAquaGreen':'btn-tmPink'}`} onClick={props.handleClose}>
          {t('modal.close')}
        </Button>
	  </Modal.Footer>
	  {/*End Footer*/}
	</Modal>
  );
}

export default DevelopmentModal;
